import { useEffect, useState } from "react"

const QUERY = "(prefers-reduced-motion: reduce)"

export default function usePrefersReducedMotion() {
  const [prefersReduced, setPrefersReduced] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return
    const mql = window.matchMedia(QUERY)
    setPrefersReduced(mql.matches)
    const handler = (event) => setPrefersReduced(event.matches)
    if (mql.addEventListener) {
      mql.addEventListener("change", handler)
      return () => mql.removeEventListener("change", handler)
    }
    mql.addListener(handler)
    return () => mql.removeListener(handler)
  }, [])

  return prefersReduced
}
